<template>
    <div class="bookshelf">
        <PageHeader></PageHeader>
        <ul class="fav-books">
            <!-- <BooksCard v-for="(item, index) in this.$store.state.favoriteBook" :key="index" :item="item"></BooksCard> -->
            <BooksCard v-for="(item, index) in favoriteBook" :key="index" :item="item"></BooksCard>
            <li @click="$router.push({path: '/Searching'})">
                <span><van-icon name="plus" /></span>
                <div class="book-detail">添加你喜欢的小说</div>
            </li>
        </ul>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import BooksCard from "@/components/BooksCard.vue";

export default {
    data() {
        return {
            favoriteBook: [
                {
                    _id: "59ba0dbb017336e411085a4e",
                    hasCp: true,
                    title: "元尊",
                    aliases: "",
                    cat: "玄幻",
                    author: "天蚕土豆",
                    site: "zhuishuvip",
                    cover: "/agent/http%3A%2F%2Fimg.1391.com%2Fapi%2Fv1%2Fbookcenter%2Fcover%2F1%2F2107590%2F2107590_718bb20f6bba4ee2910cf30d51882112.jpg%2F",
                    shortIntro:
                        "彼时的归途，已是一条命运倒悬的路。\r\n昔日的荣华，如白云苍狗，恐大梦一场。\r\n少年执笔，龙蛇飞动。\r\n是为一抹光芒劈开暮气沉沉之乱世，问鼎玉宇苍穹。\r\n \r\n复仇之路，与吾同行。\r\n一口玄黄真气定可吞天地日月星辰，雄视草木苍生。\r\n \r\n铁画夕照，雾霭银钩，笔走游龙冲九州。\r\n横姿天下，墨洒青山，鲸吞湖海纳百川。",
                    lastChapter: "正文 第一千一百零八章  七彩斩天葫",
                    retentionRatio: 64.1,
                    banned: 0,
                    allowMonthly: false,
                    latelyFollower: 240490,
                    wordCount: 2835574,
                    contentType: "txt",
                    superscript: "",
                    sizetype: -1,
                    highlight: {
                        title: ["元", "尊"]
                    }
                },
                {
                    _id: "54aa84e4bbf23c9310cc1e94",
                    hasCp: true,
                    title: "霸道总裁霸道爱",
                    aliases: "",
                    cat: "现代言情",
                    author: "雪寒冷",
                    site: "zhuishuvip",
                    cover: "/agent/http%3A%2F%2Fimg.1391.com%2Fapi%2Fv1%2Fbookcenter%2Fcover%2F1%2F87299%2F87299_a5f47c84f9704c8e95f8abf2f6fc503a.jpg%2F",
                    shortIntro:
                        "命运之轮的转动造就了一段不经意的邂逅,丘比特之箭射中两个不同世界的人.你欠我一百六十万,从现在起,你就是我的贴身女佣.一道霸道的宣誓将她囚禁在他的身边.她只想在平凡的世界里,过着平凡的生活,他的出现使她平淡的生活发生了翻天覆地的变化.",
                    lastChapter: "番外",
                    retentionRatio: 0,
                    banned: 0,
                    allowMonthly: true,
                    latelyFollower: 237,
                    wordCount: 245322,
                    contentType: "txt",
                    superscript: "",
                    sizetype: -1,
                    highlight: {
                        title: ["霸", "道", "总", "裁"]
                    }
                },
                {
                    _id: "550a8d84e3c0f94e375e4963",
                    hasCp: true,
                    title: "斗罗大陆之七绝",
                    aliases: "",
                    cat: "同人",
                    author: "君无楱",
                    site: "zhuishuvip",
                    cover: "/agent/http%3A%2F%2Fimg.1391.com%2Fapi%2Fv1%2Fbookcenter%2Fcover%2F1%2F118559%2F118559_ca1fe275438342f781f91159c61577ee.jpg%2F",
                    shortIntro:
                        "这里没有魔法，没有斗气，没有武术，却有武魂。斗罗大陆已过万载。当暗器之宗“唐门”闭幕，史莱克学院夷为平地。七绝横空出世，破碎的神魂，无法估测的魂力，神王血脉不断涌现。飘渺如此问世虚空，冥来一指神影无踪。七绝与神的战争究竟谁能获胜。",
                    lastChapter: "斗魂场的两个疯子（三）",
                    retentionRatio: 5.7,
                    banned: 0,
                    allowMonthly: true,
                    latelyFollower: 1570,
                    wordCount: 124574,
                    contentType: "txt",
                    superscript: "",
                    sizetype: -1,
                    highlight: {
                        title: ["斗", "罗", "大", "陆"]
                    }
                },
                {
                    _id: "55c831f45be2c96e1bd24d4e",
                    hasCp: true,
                    title: "斗破苍穹之大世界",
                    aliases: "",
                    cat: "同人",
                    author: "醉百川",
                    site: "zhuishuvip",
                    cover: "/agent/http%3A%2F%2Fimg.1391.com%2Fapi%2Fv1%2Fbookcenter%2Fcover%2F1%2F2032653%2F2032653_9bc0333f67294ba2940f521986a73a71.jpg%2F",
                    shortIntro: "中州之战，炎帝御宇天下，成大陆至尊\n当斗帝消失之谜解开\n大世界，精彩绝伦。呈现的是另一个通往至尊之路\n在新的世界，气吞八荒，斗破苍穹\n大世界，唯吾独尊\n希望大家喜欢",
                    lastChapter: "第八百三十七章 天威（第一卷结束）",
                    retentionRatio: 37.16,
                    banned: 0,
                    allowMonthly: false,
                    latelyFollower: 2480,
                    wordCount: 2098542,
                    contentType: "txt",
                    superscript: "",
                    sizetype: 0,
                    highlight: {
                        title: ["斗", "破", "苍", "穹"]
                    }
                }
            ]
        };
    },
    components: {
        PageHeader,
        BooksCard
    }
};
</script>

<style lang="less">
.bookshelf {
    background: rgb(245, 242, 237);
    padding-bottom: 50px;
    ul.fav-books {
        li {
            &:last-child {
                padding: 15px 0 15px 15px;

                span {
                    float: left;
                    width: 70px;
                    height: 100px;
                    margin-right: 15px;
                    background: rgb(231, 231, 231);
                    .van-icon{
                      line-height: 100px;
                      margin-left: -15px;
                      font-size: 30px;
                      color: #999;
                      left: 50%;
                    }
                }
                .book-detail {
                      line-height: 100px;
                    font-size: 16px;
                    color: #999;
                }
            }
        }
    }
}
</style>
